// Photo helpers for dealer listings.
//
// Priority ordering for showing photos:
// 1. Cover photo (dealer-selected) goes first
// 2. Enhanced (background-swapped) photos before raw
// 3. Insertion order otherwise
import { buildImageUrl } from '../services/dealerApi';

export const sortedPhotos = (photos = []) => {
  const list = [...photos];
  list.sort((a, b) => {
    if (a.is_cover && !b.is_cover) return -1;
    if (!a.is_cover && b.is_cover) return 1;
    if (a.is_enhanced && !b.is_enhanced) return -1;
    if (!a.is_enhanced && b.is_enhanced) return 1;
    return 0;
  });
  return list;
};

export const heroPhotoUrl = (photos = []) => {
  const sorted = sortedPhotos(photos);
  if (!sorted.length) return null;
  const p = sorted[0];
  return buildImageUrl(p.enhanced_url || p.url);
};

export const photoUrl = (photo) => {
  if (!photo) return null;
  return buildImageUrl(photo.enhanced_url || photo.url);
};
